<template>
  <div id="scale">
    <div class="scale_content">
      <span style="margin-right:10px;">{{item.value.scaleAttribute.startRange.description}}</span>
      <RadioGroup v-model="item.value.scaleAttribute.answer">
        <Radio
          style="margin-right: 20px;"
          v-for="(i, index) in scaleNumber"
          :key="index"
          :label="index +  Number(item.value.scaleAttribute.startRange.number)"
          @click.native="scaleItem(index)"
        ></Radio>
      </RadioGroup>
      <!-- <div
        class="scaleinput"
        v-for="(i, index) in scaleNumber"
        :key="index"
        @click="scaleItem(index)"
      >
        <span :class="index == activeIndex ? 'scolebtnhover':'scalebottom'"></span>
        <input :value="i" v-model="scaleDate" type="radio" name="scale" @click="scaleinput(index)" />
        <label>{{Number(index) + Number(item.value.scaleAttribute.startRange.number)}}</label>
      </div>-->
      <span style="margin-left:10px;">{{item.value.scaleAttribute.endRange.description}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: ['item', 'pindex'],
  data() {
    return {
      startNumber: 0,
      endNumber: 0,
      scaleNumber: 0,
      scaleDate: 0,
      //  默认
      activeIndex: -1,
    }
  },
  created: function () {
    // 查看答案默认值
    if (this.item.value.scaleAttribute.answer != '') {
      this.activeIndex =
        this.item.value.scaleAttribute.answer -
        this.item.value.scaleAttribute.startRange.number
      // 初始默认值
    } else if (this.item.value.scaleAttribute.defaultValue != '') {
      this.activeIndex =
        Number(this.item.value.scaleAttribute.defaultValue) -
        this.item.value.scaleAttribute.startRange.number
    }

    this.startNumber = this.item.value.scaleAttribute.startRange.number
    this.endNumber = this.item.value.scaleAttribute.endRange.number
    // if(!this.startNumber && !this.endNumber) {
    //     this.scaleNumber = 0
    // }else if(!this.startNumber && this.endNumber){
    //     this.scaleNumber = parseInt(this.endNumber)   + 1
    // }else if(this.startNumber && this.endNumber){
    //      this.scaleNumber = parseInt(this.endNumber) - parseInt(this.startNumber)  + 1
    // }else {
    //       this.scaleNumber = 0
    // }
    this.scaleNumber = parseInt(this.endNumber) - parseInt(this.startNumber) + 1
    // console.log(this.scaleNumber)
  },
  methods: {
    scaleinput: function (index) {
      this.activeIndex = index
    },
    scaleItem: function (index) {
      this.activeIndex = index
      this.item.value.scaleAttribute.answer =
        Number(index) + Number(this.item.value.scaleAttribute.startRange.number)
      this.$emit('scaleDate', this.item.value.scaleAttribute.answer)
    },
  },
}
</script>
<style lang="less" scoped>
#scale {
  width: 100%;
}
#scale .scale_content {
  width: 100%;
}
#scale .scaleinput {
  display: inline-block;
  width: 19%;
  height: 40px;
  line-height: 40px;
}
#scale .scolebtnhover {
  display: inline-block;
  border: 4px solid rgb(66, 134, 241);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: relative;
  top: 2px;
  margin-right: 10px;
}
#scale .scalebottom {
  display: inline-block;
  width: 12px;
  height: 12px;
  line-height: 20px;
  margin-right: 10px;
  position: relative;
  top: 2px;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 50%;
}

#scale .scaleinput input {
  opacity: 0;
  position: absolute;
}
</style>